module.exports = __webpack_public_path__ + "img/profile-2.656b02d2.jpg";